import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, ElementRef, OnInit, input } from '@angular/core';

import { GoogleTagManagerFacade } from 'ish-core/facades/gtm.facade';
import { ProductView } from 'ish-core/models/product-view/product-view.model';

import { IcmCarousalContentlet } from '../../models/dot-cms-uve-contentlet.model';

import { DotCmsUveProductCarouselListComponent } from './dot-cms-uve-product-carousel-list/dot-cms-uve-product-carousel-list.component';

@Component({
  selector: 'custom-dot-cms-uve-product-carousel',
  templateUrl: './dot-cms-uve-product-carousel.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgClass, DotCmsUveProductCarouselListComponent],
})
export class DotCmsUveProductCarouselComponent implements OnInit {
  readonly contentlet = input<IcmCarousalContentlet>(undefined);
  triggerCount = 1;
  constructor(private gtmFacade: GoogleTagManagerFacade, private elementRef: ElementRef) {}
  ngOnInit(): void {
    const gtmProduct: ProductView[] = this.contentlet()
      .productSkus.split(',')
      .map(item => {
        const skus = item.trim();
        return { sku: skus };
      });
    this.gtmFacade.setupIntersectionObserverForGTMEvent(
      this.elementRef.nativeElement,
      gtmProduct,
      this.triggerCount,
      'view_item_list'
    );
  }
}
